import { BrowserRouter, useNavigate, useMatch } from "react-router-dom";
import { useEffect } from "react";
import { AppRoutes } from "@/router";
import { I18nextProvider } from "react-i18next";
import i18n from "@/i18n";
import ScrollToTop from "@/components/feature/ScrollToTop";
import SeoManager from "@/components/feature/SeoManager";
import BackToTop from "@/components/feature/BackToTop";

/**
 * Erkennt beim allerersten Besuch die Browsersprache und leitet englische
 * Besucher automatisch auf die "/en"-Version weiter. Die Entscheidung wird
 * in localStorage gemerkt, damit sie nicht bei jedem Besuch erneut passiert.
 */
function AutoDetectLanguage() {
  const navigate = useNavigate();
  const isRoot = useMatch("/");

  useEffect(() => {
    if (localStorage.getItem("lng")) return;
    const preferEn = (navigator.language || "").toLowerCase().startsWith("en");
    localStorage.setItem("lng", preferEn ? "en" : "de");
    if (preferEn && isRoot) {
      navigate("/en", { replace: true });
    }
  }, [navigate, isRoot]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AutoDetectLanguage />
        <SeoManager />
        <ScrollToTop />
        <AppRoutes />
        <BackToTop />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;